import SHeading from "@/components/atoms/SHeading";
import SuggestPlaceCard from "@/components/molecules/SuggestPlaceCard";
import { infoSuggestCards } from "@/constants/common";
import React from "react";
import { useTranslation } from "react-i18next";

const WhereToInstall: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto mt-16">
      <SHeading
        tAlign="center"
        text={t("home.where_to_install")}
        className="font-extrabold mb-8 md:text-4xl text-xl"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {infoSuggestCards(t).map((value, index) => (
          <SuggestPlaceCard
            key={index}
            heading={value.heading}
            altText={value.alternText}
            imageSrc={value.imageSrc}
            description={value.description}
          />
        ))}
      </div>
    </div>
  );
};

export default WhereToInstall;
